import { createStore } from 'vuex'
import personalSettings from './modules/personalSettings'
import currentUser from './modules/currentUser'
import createPersistedState from 'vuex-persistedstate'
import currentMoc from './modules/currentMoc'
import currentUserAdminRoles from './modules/currentUserAdminRoles'
import overrides from './modules/overrides'
import archivingMocs from './modules/archivingMocs'
import currentCommunity from './modules/currentCommunity'

const fallbackState = {
  useFallback: false
}

const store = createStore({
  plugins: [
    createPersistedState({
      key: 'mocPersonalSettings',
      paths: ['personalSettings', 'currentUser', 'currentUserAdminRoles', 'overrides', 'currentCommunity'],
      getState: (key, storage, value) => {
        // check to see if useFallback is set to true,
        // if it is, return the state for that key
        if (fallbackState.useFallback) {
          return fallbackState[key]
        }
        try {
          return (value = storage.getItem(key)) && typeof value !== 'undefined' ? JSON.parse(value) : undefined
        } catch (err) {
          // TODO: deterimine if we need to do anything here
        }

        return undefined
      }
    })
  ],
  modules: {
    personalSettings,
    currentUser,
    currentMoc,
    currentUserAdminRoles,
    overrides,
    archivingMocs,
    currentCommunity
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {}
})

export default store
